// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

let baseUrlMaster: string, baseUrlLogin: string;
//For Local
//  baseUrlMaster = "http://localhost:8080/footlogicsapp/master/v1";
// baseUrlLogin = "http://localhost:8080/footlogicsapp/login/v1";

// for Live
// baseUrlMaster = "http://15.206.16.192:6069/footlogicsapp/master/v1";
// baseUrlLogin = "http://15.206.16.192:6069/footlogicsapp/login/v1";

// for Live New
// baseUrlMaster = "http://3.7.113.90:6067/footlogicsapp/master/v1";
// baseUrlLogin = "http://3.7.113.90:6067/footlogicsapp/login/v1";
//For Live New 2
baseUrlMaster = "https://appfl.imbsoftsolutions.in/footlogicsapp/master/v1";
baseUrlLogin = "https://appfl.imbsoftsolutions.in/footlogicsapp/login/v1";

export let serverUrl = {
  webMaster: baseUrlMaster,
  webLogin: baseUrlLogin,
};
